import { createContext } from 'react';

/**
 * Where an open menu mounts. A modal provides its own container, since a menu mounted on the
 * body would sit behind the modal and outside its focus trap.
 */
const ActionMenuPortalRoot = createContext<HTMLElement | null>(null);

export default ActionMenuPortalRoot;
